import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRoundedCornersTr = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5.5 19a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M17.5 19a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M5.5 7a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M5.5 11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M5.5 15a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M13.5 19a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0M9.5 19a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.75 4.75h2.5a6 6 0 0 1 6 6v2.5"
    />
  </svg>
);
export default SvgRoundedCornersTr;
